import React, { Component } from 'react';
import './Favourites.css';
import FavouriteEntry from './FavouriteEntry';
import ParameterErrors from '../errors/ParameterErrors';
import MenuType from '../enums/MenuType';
import isMobile from '../core/isMobile';
import Dialog from './Dialog';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import PlotComparisonManager from '../plot_detailed_information/PlotComparisonManager';
import SubMenuHeader from './SubMenuHeader';
import AssetsManager from '../assets_management/AssetsManager';
import Tutorials from '../tutorials/Tutorials';
import TutorialMessage from '../tutorials/TutorialMessage';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Favourites extends Component {
	constructor(props){
		super(props);
		const {onHide, onShowSendFavouritesBrochure, getConfiguration, callbackComparing}=props;
		this._getConfiguration = getConfiguration;
		this._callbackComparing = callbackComparing;
		this._callbackHide = onHide;
		this._buttonCompareSelectedRef = React.createRef();
		this._buttonSendMyFavouritesBrochureRef = React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._callbackShowSendFavouritesBrochure = onShowSendFavouritesBrochure;
		this._iMenuManager  = null;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._onClickFavouriteEntryRemove = this._onClickFavouriteEntryRemove.bind(this);
		this._handleClickSendMyFavouritesBrochure= this._handleClickSendMyFavouritesBrochure.bind(this);
		this._handleClickCompare = this._handleClickCompare.bind(this);
		this._updateTutorialMessages = this._updateTutorialMessages.bind(this);
		this.clear = this.clear.bind(this);
		this.state={visible:false, entries:[]};
		Tutorials.addEventListener('update', this._updateTutorialMessages);
	}
	_updateTutorialMessages(){
		this._tutorialMessageSendMyFavouritesBrochure?.dispose();
		this._tutorialMessageCompareSelected?.dispose();
		setTimeout(()=>{
			this._tutorialMessageSendMyFavouritesBrochure?.dispose();
			this._tutorialMessageCompareSelected?.dispose();
			if(Tutorials.showStep5&&this.state.visible&&this._buttonSendMyFavouritesBrochureRef.current&&Tutorials.showing&&!Tutorials.hasClickedGenerateBrochureForFavourites){
				this._tutorialMessageSendMyFavouritesBrochure = new TutorialMessage({
					message:'Generate a brochure for your favourites', elementOn:this._buttonSendMyFavouritesBrochureRef.current, 
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageSendMyFavouritesBrochure);
			}
			if(Tutorials.showStep5&&this.state.visible&&this._buttonCompareSelectedRef.current&&Tutorials.showing&&!Tutorials.hasClickedCompareFavourites){
				this._tutorialMessageCompareSelected = new TutorialMessage({
					rightAlign:true,
					message:'Compare your favourites', elementOn:this._buttonCompareSelectedRef.current, 
					hasClose:true, callbackClose:()=>{
						Tutorials.showing = false;
					},
					fixInPlace:true
				});
				Tutorials.addShowingTutorialMessage(this._tutorialMessageCompareSelected);
			}
		});
	}
	get count(){
		return this.state.entries.length;
	}
	add(favourite){
		const hash = favourite.hash;
		if(this._getEntryByHash(hash)!==null)return;
		const favouriteEntryRef = React.createRef();
		const favouriteEntry = (<FavouriteEntry favourite={favourite} 
			onClickRemove={this._onClickFavouriteEntryRemove} ref={React.createRef()} key={favourite.hash}
			configuration={this._getConfiguration()}></FavouriteEntry>);
		const entries = this.state.entries;
		entries.push(favouriteEntry);
		this.setState({entries:entries});
	}
	clear(){
		this.state.entries.forEach(favouriteEntry=>{
			favouriteEntry.onRemove&&favouriteEntry.onRemove();
		});
		this.setState({entries:[]});
	}
	get selectedFavourites(){
		const selectedEntries = this.state.entries
			.map(entry=>entry.ref.current)
			.filter(entry=>entry.selected)
			.map(entry=>entry.favourite);
		if(selectedEntries.length>0)
			return selectedEntries;
		return this.state.entries.map(entry=>entry.ref.current.favourite);
	}
	remove(hash){
		const entries = this.state.entries;
		const favouriteEntry = this._getEntryByHash(hash);
		if(favouriteEntry===null)return;
		const index = entries.indexOf(favouriteEntry);
		if(index<0)return;
		entries.splice(index, 1);
		this.setState({entries:entries});
		favouriteEntry.onRemove&&favouriteEntry.onRemove();
	}
	_onClickFavouriteEntryRemove(favourite){
		this.remove(favourite.hash);
		favourite.onRemove();
	}
	_getEntryByHash(hash){
		const entries = this.state.entries;
		for(var i=0; i<entries.length; i++){
			const entry = entries[i];
			if(entry.ref.current&&(entry.ref.current.hash===hash))return entry;
		}
		return null;
	}
	_handleClickSendMyFavouritesBrochure(){
		
		Tutorials.hasClickedGenerateBrochureForFavourites=true;
		this._tutorialMessageSendMyFavouritesBrochure?.dispose();
		const selectedPlots = this.selectedFavourites
		.map(selectedFavourite=>selectedFavourite.payload);
		const selectedPlotsBrochureEnabled = selectedPlots.filter(selectedPlot=>selectedPlot?.houseType?.brochureEnabled!==false);
		const selectedPlotsBrochureDisabled = selectedPlots.filter(selectedPlot=>selectedPlot?.houseType?.brochureEnabled===false);
		if(selectedPlotsBrochureEnabled.length>=selectedPlots.length){
			this._callbackShowSendFavouritesBrochure();
			return;
		}
		if(selectedPlotsBrochureEnabled.length<1){
			Dialog.create({preventInterraction:true, 
			options:[
			{text:"Ok", callback:()=>{}}], 
				message:"None of your favourite plots had a brochure!",  
				title:"Warning",
				onClickClose:()=>{}});
				return;
		}
		const stringSelectedPlotsWithoutBrochure = '('+selectedPlotsBrochureDisabled.map(selectedPlot=>selectedPlot.number).join(',')+')';
		const stringSelectedPlotsWithBrochure = '('+selectedPlotsBrochureEnabled.map(selectedPlot=>selectedPlot.number).join(',')+')';
		Dialog.create({preventInterraction:true, 
		options:[{text:"Yes", callback:this._callbackShowSendFavouritesBrochure},
		{text:"No", callback:()=>{}}], 
			message:`Not all your plots have a brochure ${stringSelectedPlotsWithoutBrochure}. Send for the ones that do ${stringSelectedPlotsWithBrochure}?`, 
			title:"Warning", onClickClose:()=>{}});
	}
	_handleClickCompare(){
		Tutorials.hasClickedCompareFavourites=true;
		this._tutorialMessageCompareSelected?.dispose();
		this.hide();
		this._callbackComparing();
		PlotComparisonManager.instance.compare(this.selectedFavourites.map(favourite=>favourite.payload));
	}
	get menuType(){
		return MenuType.FAVOURITES;
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
		this._callbackHide&&this._callbackHide();
	}	
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	render() {
		this._updateTutorialMessages();
		const sendMyFavouritesBrochureButton = this._getConfiguration().brochureGeneratorUrl?(
				<button ref={this._buttonSendMyFavouritesBrochureRef} className="button-send-my-favourites-brochure" 
				onClick={this._handleClickSendMyFavouritesBrochure}>Send My Favourites Brochure</button>
				):null;
		let className ="favourites menu";
		if(this.state.visible)
			className+=" visible";
		const comparisonButton = (!isMobile)&&this._getConfiguration().plotComparisonEnabled?
	(<button className="button-compare-selected"  ref={this._buttonCompareSelectedRef}
				onClick={this._handleClickCompare}>Compare</button>):null;
		const entries = this.state.entries.length>0?(
				<div className="entries-wrapper">
				<div className="entries">
				{this.state.entries}
				</div>
				{sendMyFavouritesBrochureButton}
					{comparisonButton}
				</div>
				):(<div className="no-entries">No favourites. Click the star icon on a plot menu to favourite it!</div>);
		return (<div className={className} onClick={this._handleClick} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Favourites"></SubMenuHeader>
					{entries}
				</div>);
	}
}
